import React, { useMemo, useState } from "react";
import { Table, Typography } from "antd";
import { map } from "underscore";
import { ColumnsType } from "antd/es/table";
import {
    ICrossChannelRatingAndReviewTableWidget,
    TCrossChannelTableData,
} from "@ts/common-types";

const CrossChannelRatingAndReviewTableWidget: React.FC<
    ICrossChannelRatingAndReviewTableWidget
> = ({ widgetData, expandLabel = "Show All Themes", showMoreButtonRequired }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const columnsData = useMemo(() => {
        const columns: ColumnsType<TCrossChannelTableData> = [
            {
                title: "",
                dataIndex: "metrics",
                key: "metrics",
                align: "left",
                width: "100%",
                ellipsis: true,
            },
            ...map(
                widgetData?.tableData?.[0] &&
                    Object.keys(widgetData.tableData[0]).filter((key) =>
                        key.startsWith("channelName")
                    ),
                (channelKey, index) => ({
                    title: widgetData?.tableData?.[0][channelKey],
                    dataIndex: `channel${index + 1}`,
                    key: `channel${index + 1}`,
                    align: 'center' as const,
                    width: "100%",
                    ellipsis: true,
                })
            ),
        ];
        const expandedColumns = map(columns, (col, index) =>
            index === 0
                ? {
                      ...col,
                      render: (text: string) => (
                          <div style={{ marginLeft: "10%" }}> {text} </div>
                      ),
                  }
                : col
        );

        return {
            columns,
            expandedColumns,
        };
    }, [widgetData]);

    return (
        <div style={{ margin: "20px" }}>
            <Table
                className="cross-channel-table"
                columns={columnsData.columns}
                dataSource={widgetData?.tableData}
                pagination={false}
                scroll={{ x: 200 }}
                size="middle"
                tableLayout="auto"
            />
            {isExpanded && (
                <div>
                    <Table
                        columns={columnsData.expandedColumns}
                        dataSource={widgetData?.expandedTableData}
                        pagination={false}
                        bordered={false}
                        showHeader={false}
                        scroll={{ y: 200 }}
                        size="small"
                    />
                </div>
            )}
            {showMoreButtonRequired && (
                <div className="text-center mt-4">
                    <Typography.Link
                        className="text-decoration-underline fs-6"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? "Show Less" : expandLabel}
                    </Typography.Link>
                </div>
            )}
        </div>
    );
};

export default CrossChannelRatingAndReviewTableWidget;